// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bigVideoStoryCard2Ad-m__wrapper__24mbK","side-ad":"bigVideoStoryCard2Ad-m__side-ad__2NEey","horizontal-ad":"bigVideoStoryCard2Ad-m__horizontal-ad__2dogH"};